import ApiService from '@/util/api.service'
import { toPresetPayload } from '@/components/map-v2/data/tray-presets-sync'

// Presets del video wall en apiv2, scoped al usuario de la sesión. El store
// map-v2 los usa con localStorage como caché (ver syncTrayPresets).
const BASE = '/v2/tray-presets'

export default {
  list() {
    return ApiService({ url: BASE, method: 'get' })
  },
  save(preset) {
    return ApiService({
      url: `${BASE}/${encodeURIComponent(preset.id)}`,
      method: 'put',
      data: toPresetPayload(preset),
    })
  },
  remove(id) {
    return ApiService({ url: `${BASE}/${encodeURIComponent(id)}`, method: 'delete' })
  },
  importMany(presets) {
    return ApiService({
      url: `${BASE}/import`,
      method: 'post',
      data: {
        presets: presets.filter(p => p && p.id).map(p => ({ id: p.id, ...toPresetPayload(p) })),
      },
    })
  },
}
